import { RouteConfig } from "../../../types/RouteConfig";
import { calorCashbackViewRoute } from "./cashback-view/route";
import { calorClaimFormRoute } from "./claim-form/route";
import { calorClaimsViewRoute } from "./claims-view/route";

export const calorRoutes: RouteConfig<'with-children'> = {
    name: 'Calor Cashback',
    context: 'member',
    children: [
        calorCashbackViewRoute,
        calorClaimFormRoute,
        calorClaimsViewRoute,
    ]
}